import PropTypes from "prop-types";
import "./chatReactions.scss";

const ChatReactionPicker = ({
  emojis = [],
  selected = null,
  onPick,
}) => {
  if (!emojis.length) return null;

  return (
    <div className="chat-reaction-picker" role="listbox">
      {emojis.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className={`chat-reaction-picker__emoji${
            selected === emoji ? " is-selected" : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            onPick?.(emoji);
          }}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
};

ChatReactionPicker.propTypes = {
  emojis: PropTypes.arrayOf(PropTypes.string),
  selected: PropTypes.string,
  onPick: PropTypes.func,
};

export default ChatReactionPicker;
